interface StructuredDataProps {
  type: "Organization" | "WebSite" | "WebPage" | "BreadcrumbList" | "Article" | "FAQPage";
  data: Record<string, unknown>;
}

export default function StructuredData({ type, data }: StructuredDataProps) {
  const baseData = {
    "@context": "https://schema.org",
    "@type": type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(baseData) }}
    />
  );
}

export function OrganizationSchema() {
  const data = {
    "@type": "Organization",
    name: "书香阁",
    url: "https://shuxiangge.com",
    description: "书香阁是一个专注于中文网络小说阅读与推荐的优质平台。",
    email: "contact@shuxiangge.com",
    telephone: "400-888-6688",
    address: {
      "@type": "PostalAddress",
      addressLocality: "北京",
      addressCountry: "CN",
    },
  };

  return <StructuredData type="Organization" data={data} />;
}

export function WebSiteSchema() {
  const data = {
    "@type": "WebSite",
    name: "书香阁 - 二枪入一洞苏晓月小说",
    url: "https://shuxiangge.com",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://shuxiangge.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return <StructuredData type="WebSite" data={data} />;
}

export function WebPageSchema({
  title,
  description,
  url,
  datePublished,
  dateModified,
}: {
  title: string;
  description: string;
  url: string;
  datePublished?: string;
  dateModified?: string;
}) {
  const data: Record<string, unknown> = {
    "@type": "WebPage",
    name: title,
    description,
    url,
    inLanguage: "zh-CN",
    isPartOf: { "@type": "WebSite", name: "书香阁", url: "https://shuxiangge.com" },
  };
  if (datePublished) data.datePublished = datePublished;
  if (dateModified) data.dateModified = dateModified;

  return <StructuredData type="WebPage" data={data} />;
}

export function BreadcrumbListSchema({
  items,
}: {
  items: { name: string; url: string }[];
}) {
  const data = {
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return <StructuredData type="BreadcrumbList" data={data} />;
}

export function ArticleSchema({
  title,
  description,
  url,
  datePublished,
  dateModified,
  author,
}: {
  title: string;
  description: string;
  url: string;
  datePublished: string;
  dateModified: string;
  author: string;
}) {
  const data = {
    "@type": "Article",
    headline: title,
    description,
    url,
    datePublished,
    dateModified,
    author: { "@type": "Person", name: author },
    publisher: {
      "@type": "Organization",
      name: "书香阁",
      url: "https://shuxiangge.com",
    },
    inLanguage: "zh-CN",
  };

  return <StructuredData type="Article" data={data} />;
}

export function FAQPageSchema({
  questions,
}: {
  questions: { question: string; answer: string }[];
}) {
  const data = {
    "@type": "FAQPage",
    mainEntity: questions.map((q) => ({
      "@type": "Question",
      name: q.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: q.answer,
      },
    })),
  };

  return <StructuredData type="FAQPage" data={data} />;
}